
// CONSTANTS
export const PAYMENT = {
    manual: 'A',
    paid: 'B',
    notPaid: 'C'
}